import { EditorState, Modifier, ContentBlock, genKey, DraftOffsetKey } from 'wix-rich-content-editor-common';
import { OrderedMap } from 'immutable';
export const addText = (text, editorState)=>{
    const currentContent = editorState.getCurrentContent();
    const contentWithText = Modifier.replaceText(currentContent, editorState.getSelection(), text);
    return EditorState.push(editorState, contentWithText, 'insert-characters');
};
/**
 * Adds empty lines at start/end of the document and between atomics
 * so that user can always add more content above/below an atomic
 * if its the first/last item, or between two atomics.
 */ export const fixAtomicsBlockingEditing = (editorState)=>{
    const currentContent = editorState.getCurrentContent();
    const blocksArray = currentContent.getBlocksAsArray();
    // Find atomics with missing empty blocks around them
    const atomicsThatNeedFix = [];
    // eslint-disable-next-line
    blocksArray.map((block, idx)=>{
        if (block.getType() === 'atomic') {
            const prev = blocksArray[idx - 1];
            const next = blocksArray[idx + 1];
            if (!prev || prev.getType() === 'atomic') {
                atomicsThatNeedFix.push({
                    position: 'before',
                    key: block.getKey()
                });
            }
            if (!next) {
                atomicsThatNeedFix.push({
                    position: 'after',
                    key: block.getKey()
                });
            }
        }
    });
    if (atomicsThatNeedFix.length === 0) {
        return editorState;
    }
    // Inject new empty blocks around the atomics creating a new blockMap
    const blocks = currentContent.getBlockMap();
    let blockMap = currentContent.getBlockMap();
    for (const fix of atomicsThatNeedFix){
        const newBlock = new ContentBlock({
            key: genKey()
        });
        // eslint-disable-next-line no-loop-func
        blockMap = OrderedMap().withMutations((newMap)=>{
            for (const indexedBlock of blockMap.valueSeq().toArray()){
                if (fix.position === 'before' && indexedBlock.getKey() === fix.key) {
                    newMap.set(newBlock.getKey(), newBlock);
                }
                newMap.set(indexedBlock.getKey(), indexedBlock);
                if (fix.position === 'after' && indexedBlock.getKey() === fix.key) {
                    newMap.set(newBlock.getKey(), newBlock);
                }
            }
        });
    }
    // If we updated anything set the new content
    if (blockMap.size !== blocks.size) {
        const newContentState = currentContent.merge({
            blockMap
        });
        return EditorState.set(editorState, {
            currentContent: newContentState
        });
    }
    return editorState;
};
/**
 * Adds data attribs data-empty and data-focused to the blocks
 *
 * data-empty is only applied to atomic adjacent empty unstyled blocks
 * data-focused is added to the block the selection is currently in
 *
 * @param editorState
 */ export const markEmptyAtomicAdjacentAndFocused = (editorState)=>{
    const selection = editorState.getSelection();
    const currentContent = editorState.getCurrentContent();
    const blocks = currentContent.getBlocksAsArray();
    // Find all empty blocks adjacent to atomic blocks
    const emptyBlocks = [];
    // eslint-disable-next-line
    blocks.map((block, idx)=>{
        if (block.getText() === '' && block.getType() === 'unstyled') {
            const prev = blocks[idx - 1];
            const next = blocks[idx + 1];
            if (prev && prev.getType() === 'atomic') {
                emptyBlocks.push(DraftOffsetKey.encode(block.getKey(), 0, 0));
            }
            if (next && next.getType() === 'atomic') {
                emptyBlocks.push(DraftOffsetKey.encode(block.getKey(), 0, 0));
            }
        }
    });
    // Mark the blocks with data attribs, we can then target css to
    // hide the extra lines.
    const currentBlock = currentContent.getBlockForKey(selection.getStartKey());
    const offsetKey = DraftOffsetKey.encode(currentBlock.getKey(), 0, 0);
    const query = document.querySelectorAll('[data-offset-key]');
    if (query) {
        // eslint-disable-next-line
        Array.from(query).map((node)=>{
            if (!node || !node.setAttribute) {
                // eslint-disable-next-line
                return;
            }
            const key = node.getAttribute('data-offset-key');
            if (key === offsetKey) {
                node.setAttribute('data-focused', '1');
            } else {
                node.setAttribute('data-focused', '0');
            }
            if (emptyBlocks.includes(key)) {
                node.setAttribute('data-empty', '1');
            } else {
                node.setAttribute('data-empty', '0');
            }
        });
    }
};
